import React from "react";
import "./messages.css";

const Messages = () => {
  return (
    <div className="messages-container">
      <h1 className="messages-text font-large">Coming Soon...</h1>
    </div>
  );
};

export default Messages;
